import { type ApiError, useApi } from '@omnipresentgroup/api';
import type { GetCompanyAvailableProductsAPI } from '@omnipresentgroup/types';
import { useQuery } from '@tanstack/react-query';

import { API_BASE, API_PATH } from '../constants';

const AVAILABLE_PRODUCTS_API_PATH = 'available-products';

export const getCompanyAvailableProductsKey = (companyId: string) => [
  API_PATH,
  companyId,
  AVAILABLE_PRODUCTS_API_PATH,
];

export const useCompanyAvailableProducts = ({
  companyId,
  enabled,
}: {
  companyId: string;
  enabled?: boolean;
}) => {
  const { GET } = useApi();

  const query = useQuery<GetCompanyAvailableProductsAPI, ApiError>({
    queryKey: getCompanyAvailableProductsKey(companyId),
    queryFn: () =>
      GET<GetCompanyAvailableProductsAPI>(
        `${API_BASE}/${API_PATH}/${companyId}/${AVAILABLE_PRODUCTS_API_PATH}`,
      ),
    enabled: enabled || !!companyId,
  });

  return query;
};
